import axios from "axios";

const lockUrl = (operation) =>
  `${process.env.REACT_APP_BASE_URL}/nocApi/forms/edit-lock/${operation}`;

export const acquireFormEditLock = async ({ currentSession, formId }) => {
  const response = await axios.post(
    lockUrl("acquire"),
    { currentSession, formId },
    { withCredentials: true },
  );
  const data = response?.data?.data || {};
  if (!response?.data?.success || !data.lockId) {
    throw new Error(
      response?.data?.message ||
        "The inactive form editor lock could not be acquired",
    );
  }
  return {
    formId,
    lockId: data.lockId,
    heartbeatSeconds: data.heartbeatSeconds || 30,
  };
};

export const heartbeatFormEditLock = async ({
  currentSession,
  formId,
  lockId,
}) =>
  axios.post(
    lockUrl("heartbeat"),
    { currentSession, formId, lockId },
    { withCredentials: true },
  );

export const isFormEditLockLostError = (error) =>
  error?.response?.status === 409 &&
  error?.response?.data?.code === "FORM_EDIT_LOCK_LOST";

const wait = (delayMs) =>
  new Promise((resolve) => {
    window.setTimeout(resolve, delayMs);
  });

export const renewFormEditLock = async ({
  currentSession,
  formId,
  lockId,
  attempts = 3,
  retryDelayMs = 1000,
}) => {
  let lastError;
  const totalAttempts = Math.max(1, Number(attempts) || 1);

  for (let attempt = 1; attempt <= totalAttempts; attempt += 1) {
    try {
      await heartbeatFormEditLock({ currentSession, formId, lockId });
      return true;
    } catch (error) {
      if (isFormEditLockLostError(error)) throw error;
      lastError = error;
      if (attempt < totalAttempts) {
        await wait(Math.max(0, Number(retryDelayMs) || 0));
      }
    }
  }

  throw lastError;
};

export const releaseFormEditLock = async ({ currentSession, formId, lockId }) =>
  axios.post(
    lockUrl("release"),
    { currentSession, formId, lockId },
    { withCredentials: true },
  );

export const formatFormEditLockedMessage = (error) => {
  const lockOwner = error?.response?.data?.data?.ownerEmail;
  const retryAfter = error?.response?.data?.data?.retryAfterSeconds;
  return `This form is already being edited${lockOwner ? ` by ${lockOwner}` : ""}.${retryAfter ? ` Try again in about ${retryAfter} seconds.` : ""}`;
};
